export var INLINES = /*#__PURE__*/function (INLINES) {
  INLINES["ASSET_HYPERLINK"] = "asset-hyperlink";
  INLINES["EMBEDDED_ENTRY"] = "embedded-entry-inline";
  INLINES["EMBEDDED_RESOURCE"] = "embedded-resource-inline";
  INLINES["ENTRY_HYPERLINK"] = "entry-hyperlink";
  INLINES["HYPERLINK"] = "hyperlink";
  INLINES["RESOURCE_HYPERLINK"] = "resource-hyperlink";
  return INLINES;
}({});